import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg012 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 300,
	height: 281,
	viewBox: "0 0 300 281",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.896 162.965C-14.5972 110.617 12.6136 50.9008 68.5995 29.6196L126.638 7.56399C182.661 -13.7297 246.324 11.4793 268.805 63.8019L292.105 118.035C314.598 170.389 287.381 230.099 231.395 251.38L173.357 273.436C117.34 294.73 53.677 269.521 31.1963 217.204L7.896 162.965Z",
			fill: "url(#paint0_linear_43_3)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 252H29.5",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37 252H50",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.5 252H229",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.5 252H258.5",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M266.5 252H272",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87,
			y: 45.9999,
			width: 126,
			height: 206,
			rx: 9,
			fill: "#EFEFEF",
			stroke: "black",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.711 35.1621C136.824 33.4942 138.697 32.4926 140.702 32.4926H159.269C161.274 32.4926 163.146 33.4942 164.259 35.1621L166.252 38.1474C168.912 42.1346 166.054 47.4779 161.261 47.4779H138.71C133.916 47.4779 131.058 42.1346 133.719 38.1474L135.711 35.1621Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98,
			y: 229,
			width: 112,
			height: 20,
			rx: 6,
			fill: "url(#paint1_linear_43_3)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.033 88.7547C134.162 89.9509 133.057 90.9674 131.733 91.7321C128.883 93.3778 125.531 93.5577 122.367 92.5206",
			stroke: "black",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M163 88.7273C164.399 90.2552 166.165 91.3825 168.215 91.9318C171.395 92.7836 174.678 92.0901 177.466 90.2694",
			stroke: "black",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.228 168C127.343 157.423 136.987 150 148.228 150C159.468 150 169.112 157.423 173.228 168",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.267 117.703C133.808 120.528 129.392 123.419 123.746 124.932C118.1 126.445 112.829 126.149 110.153 124.433",
			stroke: "url(#paint2_linear_43_3)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M190.302 124.433C187.627 126.149 182.356 126.445 176.71 124.932C171.064 123.419 166.647 120.528 165.188 117.704",
			stroke: "url(#paint3_linear_43_3)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M190.228 110C188.087 115.289 183.073 119 177.228 119C171.383 119 166.368 115.289 164.228 110",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.228 110C134.087 115.289 129.073 119 123.228 119C117.383 119 112.368 115.289 110.228 110",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_43_3",
				x1: 150,
				y1: 0,
				x2: 150,
				y2: 281,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C22F27" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C22F27",
					stopOpacity: .25
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_43_3",
				x1: 154,
				y1: 229,
				x2: 154,
				y2: 249,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F4483A" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D62825"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_43_3",
				x1: 110.671,
				y1: 126.365,
				x2: 135.785,
				y2: 119.635,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#DB9895",
					stopOpacity: .8
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DB9895"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_43_3",
				x1: 164.671,
				y1: 119.635,
				x2: 189.785,
				y2: 126.365,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DB9895" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DB9895",
					stopOpacity: .8
				})]
			})
		] })
	]
});
export default Svg012;
